class DZModelInfoSearch {
    /**
     * 资讯类型
     */
    type = "";

    /**
     * 资讯标题
     */
    title = "";
    /**
     * 当前页码
     */
    pageNum = 1;

    /**
     * 每页数量
     */
    pageSize = 10

    /**
     * 总数量
     */
    total = 0;
}
export default DZModelInfoSearch;
